<template>
<div>
  <b-button
  pill
  variant="success"
  class="px-4 text-center text-capitalize table-btn px-4 py-1 unclickable-status"
  :class="{
    'bg-red-danger': status == 'unpaid',
    'bg-green-success': status == 'paid',
    'green-btn': status == 'settled',
    'bg-secondary': status == 'requested'
  }"
  :size="size"
  >{{status}}</b-button>
</div>
</template>
<script>
export default {
  props: {
    status: {
      type: String,
      required: true
    },
    size: {
      type: String,
      required: false
    }
  }
}
</script>
<style scoped>
.unclickable-status {
  border: 0;
  cursor: default;
  pointer-events: none;
}
.bg-red-danger {
  background-color: #d45864;
}
.green-btn {
  color: white;
  background-color: #69dea4;
}
.bg-green-success {
  background-color: #0aa257;
  outline: none;
}
</style>
